import { useServers } from '@ottd/api';
import { useTranslation } from 'react-i18next';

import { PageHeader } from '@/components/prototype/page-header';
import { DefaultSkeleton, QueryState } from '@/components/prototype/query-state';
import { ServerListCard } from '@/pages/servers/server-list-card';

export default function ServersPage() {
  const { t } = useTranslation('server');
  const { data: servers, isLoading, isError, error } = useServers();

  return (
    <div className="mx-auto max-w-[1080px] px-4 py-8 sm:px-5">
      <PageHeader
        eyebrow={t('list.eyebrow')}
        title={t('list.title')}
        subtitle={
          servers ? t('list.subtitle', { count: servers.length }) : t('list.subtitleGeneric')
        }
      />

      <div className="mt-8">
        <QueryState
          isLoading={isLoading}
          isError={isError}
          error={error}
          isEmpty={servers?.length === 0}
          emptyLabel={t('list.empty')}
          skeleton={<DefaultSkeleton rows={6} />}
        >
          {/* Equal rows: an idle card (no progress row) stays as tall as a live one. */}
          <div className="grid auto-rows-fr gap-4 md:grid-cols-2">
            {servers?.map((server) => (
              <ServerListCard key={server.id} server={server} />
            ))}
          </div>
        </QueryState>
      </div>
    </div>
  );
}
